<template>
  <v-flex pt-3 xs12>
    <h5 style="font-weight: medium; color: red;">A cancellation fee of {{(bookingForm.booking.booking_cancellation_fee.amount / 100).toFixed(2)}} was charged for this booking</h5>
    <p v-if="bookingForm.booking.booking_cancellation_fee.authorizer != null" style="font-weight: medium">Authorized by {{bookingForm.booking.booking_cancellation_fee.authorizer}}</p>
    <p v-else style="font-weight: medium">Authorized by system policy</p>
    <v-col wrap align-start>
      <v-btn small class="text-none" target="_blank" :href="cardPaymentLink"
        >View Cancellation Fee on Stripe</v-btn
      >
      <p
        >{{(bookingForm.booking.booking_cancellation_fee.refunded ? "Cancellation fee has been fully or partially refunded. " : "") + ("Amount available for refund " + amountAvailableForRefund) }}</p>
      
      <v-flex pt-2>
        <StripeCancellationFeeRefund :bookingForm="bookingForm"/>
     </v-flex>
    </v-col>
  </v-flex>
</template>

<script>
import StripeCancellationFeeRefund from "@/components/booking/StripeCancellationFeeRefund.vue";

import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "StripeTransaction",
  mounted: function () {
    console.log("StripeTransaction");

    this.getAmountAvailableToRefund();
  },
  components: {
    StripeCancellationFeeRefund
  },
  props: {
    bookingForm: Object,
  },
  data: function () {
    return {
      dialog: false,
      loading: false,
      transactions: [],
      amountAvailableForRefund: "£--.--"
    };
  },
  computed: {
    hasOutboundAndReturn: function() {
      return (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null);
    },
    outboundAndReturnString: function() {
      if (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null) {
        return "This stripe payment is associated with two bookings.<br><b>Outbound:</b> " + this.bookingForm.booking.cart.outboundBookingId + "<br><b>Return:</b> " + this.bookingForm.booking.cart.returnBookingId;
      } 

      return "";
    },
    cardPaymentLink: function () {
      return (
        "https://dashboard.stripe.com/search?query=" +
        (this.bookingForm.booking.booking_cancellation_fee.paymentIntentId)
      );
    },
  },
  methods: {
    getAmountAvailableToRefund: async function () {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/booking/getRefundableAmountForPaymentIntent?token=${this.bookingForm.booking.booking_cancellation_fee.paymentIntentId}`;

        let response = await axios.get(url, {
          params: {},
        });

       this.amountAvailableForRefund = "£" + (response.data.amount / 100).toFixed(2)

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get customer " + error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>

   
